var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_ionic-ios-checkmark-circle-outline",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37a450",
    id: "Path_195",
    d: "M16.4 12.744l-.49-.5a.105.105 0 0 0-.078-.033.1.1 0 0 0-.078.033l-3.4 3.424-1.234-1.241a.108.108 0 0 0-.156 0l-.5.5a.111.111 0 0 0 0 .159l1.56 1.56a.493.493 0 0 0 .326.159.517.517 0 0 0 .323-.153l3.732-3.752a.119.119 0 0 0-.005-.156z",
    className: "cls-1",
    transform: "translate(-7.375 -8.375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37a450",
    id: "Path_196",
    d: "M9.375 4.183A5.19 5.19 0 1 1 5.7 5.7a5.158 5.158 0 0 1 3.672-1.52m0-.808a6 6 0 1 0 6 6 6 6 0 0 0-6-6z",
    className: "cls-1",
    transform: "translate(-3.375 -3.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ffc46c8e0c591a248373e8b01ce19072.svg";
export { ForwardRef as ReactComponent };